import { Box } from "@chakra-ui/react";
import ExternalUserChatProfile from "./ExternalUserChatProfile";

function SearchUser({
  hoverBgColor,
  setChatID,
  selectedBorderColor,
  selectChatBg,
  props,
  searchResult,
}) {
  return searchResult && searchResult?.length > 0
    ? searchResult?.map((data) => {
        return (
          <Box
            key={data?.userId}
            borderRadius={"7px"}
            p="7px"
            cursor={"pointer"}
            border={
              data?.userId === props?.selectedChat?.userId
                ? `1px solid ${selectedBorderColor}`
                : ""
            }
            bg={
              data?.userId === props?.selectedChat?.userId ? selectChatBg : ""
            }
            onClick={() => {
              props?.setSelectedChat(data);
              setChatID(data?.chatId);
            }}
            _hover={{ bg: hoverBgColor }}
          >
            <ExternalUserChatProfile
              selectedChat={props?.selectedChat}
              chat={data}
            />
          </Box>
        );
      })
    : null;
}

export default SearchUser;
